import useApi from "@apexl/icarus-core/src/services/api";
import useAjaxColumnDataStore from "@root/store/ajaxColumnDataStore";

async function getData(tableId, route, field, params, primaryKey) {
  const { setDataForColumn, getDataForColumn } = useAjaxColumnDataStore();

  async function fetchFromApi(route, field, params) {
    const api = useApi()

    const { data: { data } } = await api.get(route, {
      params: {
        field,
        data: params
      },
      paramsSerializer: (params) => {
        let _params = [];
        for (let key in params) {
          if (params.hasOwnProperty(key)) {
            switch (typeof params[key]) {
              case 'object':
                _params.push(`${key}=${JSON.stringify(params[key])}`);
                break;
              default:
                _params.push(`${key}=${params[key]}`);
                break;
            }
          }
        }

        return _params.join('&');
      },
    });

    return data;
  }

  const primaryKeys = params[primaryKey];

  const output = {};
  const toFetch = [];

  primaryKeys.forEach(id => {
    const data = getDataForColumn(tableId, field, id);


    if (typeof data !== 'undefined') {
      output[id] = data;
    } else {
      toFetch.push(id);
    }
  })

  if (toFetch.length) {
    const fetched = await fetchFromApi(route, field, params);
    Object.entries(fetched).forEach(([id, value]) => {
      output[id] = value;
      setDataForColumn(tableId, field, id, value);
    });
  }

  return output;

}


export default async function (tabulator, route, field, { primaryKey, additionalFields }) {

  function mapParams() {
    const output = {}

    const fields = [
      primaryKey,
      ...additionalFields
    ]


    const data = tabulator.getData()
        .map(row => Object.entries(row).filter(([key]) => fields.includes(key)));

    data.forEach(row => row.forEach(([key, value]) => {
      if (!output.hasOwnProperty(key)) {
        output[key] = [];
      }

      output[key].push(value);
    }));

    return output;
  }

  const params = mapParams()

  if (!Object.entries(params).length) {
    return {};
  }

  const data = await getData(tabulator.element.id, route, field, params, primaryKey)

  const rows = tabulator.getRows();
  rows.forEach((row) => {
    const id = row.getData()[primaryKey];
    const cell = row.getCell(field);
    if (cell && typeof id !== 'undefined' && data.hasOwnProperty(id)) {
      cell._loaded = true;
      cell.setValue(data[id]);
    }
  })
}
